import keyCodes from "../../utils/key-codes.js";

export default {
   data: function() {
      return {
        height: 0,
        width: 0,
        currentIndex: 0,
        imageLoaded: false,
      };
  },

  created() {
    this.fetchSlides();
    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('resize', this.onResize);
  },

  destroyed() {
    window.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('resize', this.onResize);
  },

  mounted() {
    window.MoMA.ScrollManager.preventScroll(this.$el);
  },

  computed: {
    spinnerClass() {
      if (this.imageLoaded) {
        return "overlay__image-container--sequence spinner";
      }
      return "overlay__image-container--sequence spinner spinner--visible";
    },
  },

  methods: {
    reset() {
      this.imageLoaded = false;
      this.height = 0;
      this.width = 0;
      this.customReset();
      this.updateHistory();
    },

    previous() {
      if (this.hasPreviousSlide) {
        this.currentIndex -= 1;
        this.reset();
      }
    },

    next() {
      if (this.hasNextSlide) {
        this.currentIndex += 1;
        this.reset();
      }
    },

    onResize() {
      this.height = Math.round(this.$refs.slideImage.height);
      this.width = Math.round(this.$refs.slideImage.width);
    },
    // intermitent step toward using focus trap plugin over trapTab
    onKeyDown(event) {
      switch (event.keyCode) {
        case keyCodes.ESCAPE:
          return this.$emit('close');
        case keyCodes.LEFT:
          return this.previous();
        case keyCodes.RIGHT:
          return this.next();
      }
    },
  }
};
